
import { useState, FC, useEffect } from "react";
import { BaseModalWindow } from "../../../components/modalWindows/BaseModalWindow";
import { ILotsByIdDTO } from "../../../libs/core-api-requests/accounting/lotRequest";
import { DefaultGrid } from '../../../components/grids/default/defaultGrid';
import { v4 as uuidv4 } from 'uuid';
import useGridFilter from '../../../system/hooks/useGridFilter';
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import LotsSimpleGridPluginSettings from "./LotsSimpleGridPluginSettings";
import { LoadingStatus } from "../../../@types/enumsGlobal";
import { GroupProcessingButton } from "./LotsGrid";
import { ToolbarWrapper } from "../../../components/plugins/ToolbarWrapper";
import { Spinner } from "../../../components/spiner/Spinner";
import { ILotsByIdMapDTO } from "./LotsSimpleSelectorModal";
import { useTranslation } from "react-i18next";

interface ISelectingFromLots extends IGridSelectorModalProps {
    data: ILotsByIdDTO[]
}

const LotsMultipleSelectorModal: FC<ISelectingFromLots> = (props) => {

    const [gridFilter, dispatchGridFilter] = useGridFilter();
    const [totalCount, setTotalCount] = useState<number>(0);
    const [data, setData] = useState<ILotsByIdMapDTO[]>([]);
    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? {} as IEntitySimpleDTO)
    const [loadingData, setLoadingData] = useState<LoadingStatus>(LoadingStatus.InProcess);
    const [multipleSelect, setMultipleSelect] = useState(false);
    const [selectedItem, setSelectedItem] = useState<IGridRow | undefined>(undefined);
    const [selectedItems, setSelectedItems] = useState<IGridRow[]>([]);
    const { t } = useTranslation();
    
    const setMapping = (val: ILotsByIdDTO[]) => {
        let temp: ILotsByIdMapDTO[] = []
        val.map((ii) => {
            let lot = {
                idGlobal: ii.idGlobal,
                quantityAdd: ii.quantityAdd,
                quantitySub: ii.quantitySub,
                quantityRem: ii.quantityRem,
                quantityRes: ii.quantityRes,
                storeName: ii.store.displayName,
                goodsName: ii.goods.displayName,
                internalBarcode: ii.internalBarcode,
                productMargin: ii.productMargin,
                retailPrice: ii.retailCostInfo.price,
                retailPriceIncVat: ii.retailCostInfo.priceIncVat,
                retailSum: ii.retailCostInfo.sum,
                retailSumIncVat: ii.retailCostInfo.sumIncVat,
                retailVat: ii.retailCostInfo.vat,
                retailVatSum: ii.retailCostInfo.vatSum,
                supplierPrice: ii.supplierCostInfo.price,
                supplierPriceIncVat: ii.supplierCostInfo.priceIncVat,
                supplierSum: ii.supplierCostInfo.sum,
                supplierSumIncVat: ii.supplierCostInfo.sumIncVat,
                supplierVat: ii.supplierCostInfo.vat,
                supplierVatSum: ii.supplierCostInfo.vatSum,
                scalingRatioDisplayName: ii.scalingRatio.displayName
            } as ILotsByIdMapDTO
            temp.push(lot)
        }
        )
        return temp;
    }

    const handlerGroupClick = () => {
        setMultipleSelect(prev => !prev);
        setSelectedItems([]);
    }

    useEffect(() => {
        setData(setMapping(props.data))
        setTotalCount(totalCount)
        data.length > 0 ? setLoadingData(LoadingStatus.Completed) : setLoadingData(LoadingStatus.NoData)
    }, [gridFilter])

    return (
        <BaseModalWindow
            header={t('accounting.lots.selectLots')}
            ok={{
                onClick: () => {props.ok?.(selectedItems.length > 0 ? selectedItems : selectedItem); props.cancel?.()},
                title: t('general.saveAndClose')
            }}
            cancel={{
                onClick: () => {
                    props.cancel?.()
                },
                title: t('general.closeWithoutSaving')
            }}
        >   
            <ToolbarWrapper>
                <GroupProcessingButton
                    data={data}
                    multipleSelect={multipleSelect}
                    activateGroupProcessing={props.activateGroupProcessing}
                    handlerGroupClick={handlerGroupClick}
                    selectedItems={selectedItems}
                />
            </ToolbarWrapper>
            {loadingData ? (
                <Spinner />
            ) : (
                <DefaultGrid
                    gridId={uuidv4()}
                    data={data}
                    filter={gridFilter}
                    totalCount={totalCount}
                    plugin={LotsSimpleGridPluginSettings}
                    multipleSelect={multipleSelect}
                    onSelect={(row) => {
                        row && setSelectedItem(row)
                    }}
                    onMultipleSelect={(rows) => {
                        setSelectedItems(rows ? rows : []);
                    }}
                    selectedItem={selectedItem}
                    selectedItems={selectedItems}
                    numbering={true}
                    onSort={(i) => { dispatchGridFilter({ type: "sort", payload: i.propertyName }) }}
                    onFilterDelete={(i) => { dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName }) }}
                    onPageNumberChange={(n) => { dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } }) }}
                    onNumberPerPageChange={(n) => {
                        dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })
                    }}
                    onDoubleClick={(row) => {
                        setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                        props.ok?.(entity)
                        props.cancel?.()
                    }}
                />
            )
            }
        </BaseModalWindow>
    )
}

export default LotsMultipleSelectorModal